import { Link } from 'react-router-dom';
import type { Anime } from '@/mocks/anime';

interface AnimeCardProps {
  anime: Anime;
  size?: 'small' | 'medium' | 'large';
}

export default function AnimeCard({ anime, size = 'medium' }: AnimeCardProps) {
  const imageHeight = size === 'small' ? 'h-48' : size === 'large' ? 'h-72' : 'h-64';

  return (
    <Link
      to={`/anime/${anime.id}`}
      className="anime-card-hover block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 group cursor-pointer"
    >
      <div className={`relative ${imageHeight} overflow-hidden`}>
        <img
          src={anime.cover}
          alt={anime.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            anime.status === '完结'
              ? 'bg-primary-500 text-white'
              : 'bg-accent-500 text-background-50'
          }`}>
            {anime.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-background-900/70 text-accent-300">
            {anime.episodes}集
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span className="text-white text-xs font-medium">{anime.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {anime.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{anime.description}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {anime.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-700">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}